import { Component, Input, OnInit } from '@angular/core';
import { SetPulsanti } from 'src/app/shared/models/node';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { NodeService } from 'src/app/shared/services/node.services';

@Component({
  selector: 'app-sample-button',
  templateUrl: './sample-button.component.html',
  styleUrls: ['./sample-button.component.scss']
})
export class SampleButtonComponent implements OnInit {

  @Input() block: SetPulsanti[] = [];
  @Input() column: string = '';
  public classColumn: string = '';

  constructor(
    public nodeService: NodeService,
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void { }

  setTypeButton(type: string): string {
    let typeButton: string;
    switch (type) {
      case "Primario":
        typeButton = 'a-primary';
        break;
      case "Secondario":
        typeButton = 'a-secondary';
        break;
      case "Terziario":
        typeButton = 'a-tertiary';
        break;
      default:
        typeButton = 'a-primary';
        break;
    }
    return typeButton;
  }

  public prettyPrintLabel(label: string) {
    return label
      .replace("&amp;", '&')
      .replace("&lt;", '<')
      .replace("&gt;", '>')
      .replace("&quot;", '/')
      .replace("&#039;", '\'');
  }

}
